import React, { useEffect, useState } from 'react';
import styles from './signin.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { signInUser } from '../SagaRedux/Slice';
import MessageHandler from '../Signup/MessageHandler';
import { useNavigate } from 'react-router-dom';
import { warmBackend } from '../../util/warmBackend';
import { Eye, EyeOff } from 'lucide-react';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, user, token, error } = useSelector((state) => state.app);

  const isLoading = status === 'loading';

  useEffect(() => {
    warmBackend();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;
    dispatch(signInUser({ email: email.trim(), password }));
  };

  useEffect(() => {
    if (status === 'success' && user && token) {
      navigate('/dashboard', { replace: true });
    }
  }, [status, user, token, navigate]);

  return (
    <div className={styles.bodyContainer}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <div className={styles.formContainer}>
            <div className={styles.box}>
              <form className={styles.form} onSubmit={handleSubmit} noValidate>
                <p className={styles.signupText}>Sign in</p>
                <p className={styles.textInformation}>Enter your details to access your account</p>

                <div className={styles.emailContainer}>
                  <div className={styles.inputBox}>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span>Email</span>
                    <i></i>
                  </div>
                </div>

                <div className={styles.passwordContainer}>
                  <div className={styles.inputBox}>
                    <input
                      id="password"
                      name="password"
                      className={styles.passwordInput}
                      type={showPassword ? 'text' : 'password'}
                      autoComplete="current-password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span>Password</span>
                    <i></i>
                    <button
                      type="button"
                      className={styles.passwordToggle}
                      onClick={() => setShowPassword((visible) => !visible)}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                      aria-pressed={showPassword}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                  <button
                    type="button"
                    className={styles.forgotpassword}
                    onClick={() => navigate('/forgotpassword')}
                  >
                    Forgot password?
                  </button>
                </div>

                {status === 'failed' && error && (
                  <p className={styles.formError} role="alert">{error}</p>
                )}

                <div className={styles.btnContainer}>
                  <button type="submit" disabled={isLoading} aria-busy={isLoading}>
                    {isLoading && <span className="cc-spinner" />}
                    {isLoading ? 'Signing in...' : 'Sign In'}
                  </button>
                </div>

                <div className={styles.alreadyAccountContainer}>
                  <p className={styles.alreadyAccount}>
                    Don&apos;t have an account?
                    <span className={styles.alreadySignin} onClick={() => navigate('/signup')}> Sign up</span>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className={styles.rightContainer}>
          <p className={styles.panelTagline}>Your campus marketplace</p>
        </div>
      </div>
      <MessageHandler />
    </div>
  );
};

export default Signin;
